import { render, staticRenderFns } from "./spanTime.vue?vue&type=template&id=ed7e41de"
import script from "./spanTime.vue?vue&type=script&lang=js"
export * from "./spanTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports